export default "__VITE_ASSET__Csu7FvKJ__"